export const MEASUREMENT_DATE_DOCUMENTS_TREE_LABELS = {
  emptyDescription: 'This measurement date does not have folders or documents yet.',
  emptyTitle: 'No documents found',
  errorDescription: 'Refresh the page or select another measurement date.',
  errorTitle: 'Documents could not be loaded',
  collapseFolder: (folderName: string) => `Collapse ${folderName}`,
  collapseCompanyGroup: (companyName: string) => `Collapse ${companyName} documents`,
  dragOverlayDescription: 'Drop on a highlighted destination to move this file',
  dragOverlayUnavailableDescription: 'Drop is not available here',
  fileMoveOverlayLabel: 'Moving file',
  dropTargetOverlayFileLabel: 'file',
  dropTargetOverlayTitle: (targetName: string) => `Release to move file to ${targetName}`,
  dragHandle: (fileName: string) => `Move ${fileName}`,
  emptyFolderLabel: 'Empty',
  emptyFolderRow: (folderName: string) => `${folderName}, empty folder`,
  uploadFirstDocument: 'Upload first document',
  rootDropDescription: (targetName: string) => `Release to move file to ${targetName}`,
  rootDropTargetLabel: 'this measurement date',
  expandFolder: (folderName: string) => `Expand ${folderName}`,
  expandCompanyGroup: (companyName: string) => `Expand ${companyName} documents`,
  renameFolder: (folderName: string) => `Edit ${folderName}`,
  saveFolderName: (folderName: string) => `Save ${folderName} folder name`,
  showMoreDocuments: (count: number) => `Show ${count} more ${count === 1 ? 'document' : 'documents'}`,
  selectFolderDocuments: (folderName: string) => `Select documents in ${folderName}`,
  selectCompanyDocuments: (companyName: string) => `Select documents in ${companyName}`,
  selectFile: (fileName: string) => `Select ${fileName}`,
  skeletonRowCount: 5,
} as const;

export const MEASUREMENT_DATE_DOCUMENTS_TREE_ROOT_SELECTOR =
  '[data-measurement-date-documents-tree-root="true"]';
export const MEASUREMENT_DATE_DOCUMENTS_TREE_ROW_DEPTH_ATTRIBUTE = 'data-measurement-date-documents-tree-depth';
export const MEASUREMENT_DATE_DOCUMENTS_TREE_ROW_SELECTOR =
  '[data-measurement-date-documents-tree-row="true"]';
export const MEASUREMENT_DATE_DOCUMENTS_TREE_COPY_TARGET_SELECTOR =
  '[data-firm-documents-measurement-date-copy-target="true"]';
export const MEASUREMENT_DATE_DOCUMENTS_TREE_COPY_TARGET_ID_ATTRIBUTE =
  'data-firm-documents-measurement-date-copy-target-id';
export const MEASUREMENT_DATE_DOCUMENTS_TREE_COPY_TARGET_LABEL_ATTRIBUTE =
  'data-firm-documents-measurement-date-copy-target-label';
export const MEASUREMENT_DATE_DOCUMENTS_TREE_MEASUREMENT_DATE_DROP_TARGET_LABEL_ATTRIBUTE =
  'data-firm-documents-measurement-date-drop-target-label';
export const MEASUREMENT_DATE_DOCUMENTS_TREE_MEASUREMENT_DATE_DROP_TARGET_SELECTOR =
  `[${MEASUREMENT_DATE_DOCUMENTS_TREE_MEASUREMENT_DATE_DROP_TARGET_LABEL_ATTRIBUTE}]`;

export const MEASUREMENT_DATE_DOCUMENTS_TREE_HIGHLIGHT_SCROLL_DELAY_MS = 220;

export const MEASUREMENT_DATE_DOCUMENTS_TREE_AI_FILE_ICON_SRC = '/images/scalar_ai_file.svg';
export const MEASUREMENT_DATE_DOCUMENTS_TREE_GENERATED_SOURCE_VALUE = 'generation_job';
